// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router.js'
import { store } from './store.js'
import firebase from 'firebase/app'
import 'firebase/auth'
import { config } from './firebaseConfig.js'

// import '@/assets/scss/app.scss'
import 'firebaseui/dist/firebaseui.css'

Vue.config.productionTip = false

firebase.initializeApp(config)

// handle page reloads
let app
firebase.auth().onAuthStateChanged(user => {
  // console.log(user)

  if (!app) {
    app = new Vue({
      el: '#app',
      router: router,
      store: store,
      render: h => h(App)
      // created () {
      //   if (!firebase.apps.length) {
      //     firebase.initializeApp(config);
      //   }
      //   firebase.auth().onAuthStateChanged((user) => {
      //     if (user) {
      //       this.$router.push('/dashboard')
      //     }
      //   })
      // }
    })
  }

  store.commit('firebaseUser', user)
})



// WEBPACK FOOTER //
// ./src/main.js